<template>
    <div class="table-empty">
        <img class="icon" src="@/assets/images/nodata.png" alt="">
        <h4>暂无数据</h4>
    </div>
</template>

<script>
export default {
    methods: {
        
    }
}
</script>

<style lang="less" scoped>
    .table-empty {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .icon {
            width: 100px;
            height: 100px;
            margin-bottom: 16px;
        }
        h4 {
            font-weight: bold;
            font-size: 16px;
            color: #151B26;
            line-height: 24px;
            margin-bottom: 12px;
        }
    }
</style>